import JoditEditor, { IJoditEditorProps } from "jodit-react";
import { useRef, useEffect, useState, useMemo } from "react";
import { debounce } from "lodash";

const HtmlCode = ({
  content,
  setContent,
  label = "",
  placeholder = "Start typing here...",
}) => {
  const editor = useRef(null);

  const handleBlur = (newContent) => {
    if (typeof newContent === "string") {
      setContent(newContent);
    }
  };

  const configed = {
    readonly: true,
    height: "50%",
    uploader: {
      insertImageAsBase64URI: true,
    },
    placeholder: "Start typing here...",
    toolbar: false,
  };
  const config = useMemo(
    () => ({
      readonly: false,
      height: "300px",
      uploader: {
        insertImageAsBase64URI: true,
      },
      placeholder: placeholder || "Start typing here...",
      // buttons: [
      //   "bold",
      //   "italic",
      //   "underline",
      //   "|",
      //   "ul",
      //   "ol",
      //   "|",
      //   "outdent",
      //   "indent",
      //   "|",
      //   "image",
      //   "|",
      //   "align",
      //   "undo",
      //   "redo",
      //   "|",
      //   "hr",
      //   "eraser",
      //   "fullsize",
      //   "|",
      //   "link"
      // ],
    }),
    [placeholder]
  );

  // Ensure content is always a string
  const safeContent = typeof content === "string" ? content : "";

  return (
    <>
      {/* {isVersioned ? (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <p className="inline-block text-base font-medium">Old Text</p>
          <div className="xl:col-span-12">
            <label
              htmlFor="phoneNumberIn"
              className="inline-block mb-2 text-base font-medium"
            >
              {label}
            </label>
            <JoditEditor
              ref={editor}
              value={versionedValue}
              config={configed}
              onBlur={handleBlur}
              // onChange={handleChange}
            />
          </div>
        </div>
      ) : null} */}
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
        {/* <p className="inline-block mt-4 text-base font-medium">New Text</p> */}
        <div className="xl:col-span-12">
          <label
            htmlFor="phoneNumberIn"
            className="inline-block mb-2 text-base font-medium"
          >
            {label}
          </label>
          <JoditEditor
            ref={editor}
            value={safeContent}
            config={config}
            onChange={(newContent) => {
              // Ensure we always set a string value
              setContent(typeof newContent === "string" ? newContent : "");
            }}
          />
        </div>
      </div>
    </>
  );
};

export default HtmlCode;
